import { ISiteDetails } from "../../api/ISiteDetails";
import { ILicenceProfile } from "../../api/LicenceProfile";
import EpaCard from "../../leap-components/EpaCard";
import EpaField from "../../leap-components/EpaField";

interface ILicenceProfileSiteDetailsProps {
  siteDetails: ISiteDetails;
  licenceProfile: ILicenceProfile;
}

const UrbanWasteWaterSiteDetails = ({
  siteDetails,
  licenceProfile,
}: ILicenceProfileSiteDetailsProps) => {
  var bodyElements = (
    <div>
      <EpaField label={"Urban Area"} value={siteDetails.city} />
      <EpaField label={"County"} value={siteDetails.county} />
      <EpaField label={"Eircode"} value={siteDetails.eircode} />
      <EpaField
        label={"Urban Area PE"}
        value={licenceProfile.activeLicenceVersion.urban_areape}
      />
      <EpaField label={"Plant Design PE"} value={siteDetails.plantcapacitype} />
      <EpaField label={"Treatment Type"} value={siteDetails.treatmenttype} />
      <EpaField label={"UV Treatment"} value={siteDetails.uvtreatment} />
      <EpaField label={"Priority Site"} value={licenceProfile.prioritySite} />
    </div>
  ) as JSX.Element;

  return <EpaCard title={"Site Details"} content={bodyElements} />;
};

export default UrbanWasteWaterSiteDetails;
